'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimingFunction = function () {
	function TimingFunction() {
		_classCallCheck(this, TimingFunction);
	}

	_createClass(TimingFunction, [{
		key: 'value',
		value: function value(percent) {
			return percent;
		}
	}]);

	return TimingFunction;
}();

TimingFunction.functions = {};
TimingFunction.functions.linear = TimingFunction;
TimingFunction.functions.steps = function (_TimingFunction) {
	_inherits(_class, _TimingFunction);

	function _class(args) {
		_classCallCheck(this, _class);

		var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

		var count = args[0];
		var which = args[1];
		_this.count = count;
		_this.which = which;
		_this.bounds = [];
		if (which == 'start') {
			_this.bounds[0] = { start: 0, end: 0, value: 0 };
			for (var i = 0; i < count; i++) {
				_this.bounds[_this.bounds.length] = { start: i / count, end: (i + 1) / count, value: (i + 1) / count };
			}
		} else {
			for (var i = 0; i < count; i++) {
				_this.bounds[_this.bounds.length] = { start: i / count, end: (i + 1) / count, value: i / count };
			}
			_this.bounds[_this.bounds.length - 1].end = 0.99999999;
			_this.bounds[_this.bounds.length] = { start: 1, end: 1, value: 1 };
		}
		return _this;
	}

	_createClass(_class, [{
		key: 'value',
		value: function value(percent) {
			percent = Math.min(percent, 1);
			percent = Math.max(percent, 0);
			return this.bounds.filter(function (v) {
				return v.start >= percent && v.end <= percent;
			})[0].value;
		}
	}]);

	return _class;
}(TimingFunction);

TimingFunction.functions['cubic-bezier'] = function (_TimingFunction2) {
	_inherits(_class2, _TimingFunction2);

	function _class2(args) {
		_classCallCheck(this, _class2);

		var _this2 = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));

		_this2.x1 = args[0];
		_this2.x2 = args[2];
		_this2.y1 = args[1];
		_this2.y2 = args[3];
		return _this2;
	}

	_createClass(_class2, [{
		key: 'curve',
		value: function curve(t, q1, q2) {
			var v = 1 - t;
			return 3 * v * v * t * q1 + 3 * v * t * t * q2 + t * t * t;
		}
	}, {
		key: 'curveX',
		value: function curveX(t) {
			return this.curve(t, this.x1, this.x2);
		}
	}, {
		key: 'curveY',
		value: function curveY(t) {
			return this.curve(t, this.y1, this.y2);
		}
	}, {
		key: 'derivativeCurveX',
		value: function derivativeCurveX(t) {
			var v = 1 - t;
			return 3 * (2 * (t - 1) * t + v * v) * this.x1 + 3 * (-t * t * t + 2 * v * t) * this.x2;
		}
	}, {
		key: 'value',
		value: function value(percent) {
			var epsilon = 1000 / 60 / 200 / 4;

			var x = percent,
			    t0,
			    t1,
			    t2,
			    x2,
			    d2,
			    i;
			for (t2 = x, i = 0; i < 8; i++) {
				x2 = this.curveX(t2) - x;
				if (Math.abs(x2) < epsilon) return this.curveY(t2);
				d2 = this.derivativeCurveX(t2);
				if (Math.abs(d2) < 1e-6) break;
				t2 = t2 - x2 / d2;
			}

			t0 = 0, t1 = 1, t2 = x;
			if (t2 < t0) return this.curveY(t0);
			if (t2 > t1) return this.curveY(t1);

			while (t0 < t1) {
				x2 = this.curveX(t2);
				if (Math.abs(x2 - x) < epsilon) return this.curveY(t2);
				if (x > x2) t0 = t2;else t1 = t2;
				t2 = (t1 - t0) * .5 + t0;
			}
			return this.curveY(t2);
		}
	}]);

	return _class2;
}(TimingFunction);

TimingFunction.functions.ease = function (_TimingFunction$funct) {
	_inherits(_class3, _TimingFunction$funct);

	function _class3() {
		_classCallCheck(this, _class3);

		return _possibleConstructorReturn(this, (_class3.__proto__ || Object.getPrototypeOf(_class3)).call(this, [0.25, 0.1, 0.25, 1]));
	}

	return _class3;
}(TimingFunction.functions['cubic-bezier']);
TimingFunction.functions['ease-in'] = function (_TimingFunction$funct2) {
	_inherits(_class4, _TimingFunction$funct2);

	function _class4() {
		_classCallCheck(this, _class4);

		return _possibleConstructorReturn(this, (_class4.__proto__ || Object.getPrototypeOf(_class4)).call(this, [0.42, 0, 1, 1]));
	}

	return _class4;
}(TimingFunction.functions['cubic-bezier']);
TimingFunction.functions['ease-in-out'] = function (_TimingFunction$funct3) {
	_inherits(_class5, _TimingFunction$funct3);

	function _class5() {
		_classCallCheck(this, _class5);

		return _possibleConstructorReturn(this, (_class5.__proto__ || Object.getPrototypeOf(_class5)).call(this, [0.42, 0, 0.58, 1]));
	}

	return _class5;
}(TimingFunction.functions['cubic-bezier']);
TimingFunction.functions['ease-out'] = function (_TimingFunction$funct4) {
	_inherits(_class6, _TimingFunction$funct4);

	function _class6() {
		_classCallCheck(this, _class6);

		return _possibleConstructorReturn(this, (_class6.__proto__ || Object.getPrototypeOf(_class6)).call(this, [0, 0, .58, 1]));
	}

	return _class6;
}(TimingFunction.functions['cubic-bezier']);
TimingFunction.functions['step-start'] = function (_TimingFunction$funct5) {
	_inherits(_class7, _TimingFunction$funct5);

	function _class7() {
		_classCallCheck(this, _class7);

		return _possibleConstructorReturn(this, (_class7.__proto__ || Object.getPrototypeOf(_class7)).call(this, [1, 'start']));
	}

	return _class7;
}(TimingFunction.functions.steps);
TimingFunction.functions['step-end'] = function (_TimingFunction$funct6) {
	_inherits(_class8, _TimingFunction$funct6);

	function _class8() {
		_classCallCheck(this, _class8);

		return _possibleConstructorReturn(this, (_class8.__proto__ || Object.getPrototypeOf(_class8)).call(this, [1, 'end']));
	}

	return _class8;
}(TimingFunction.functions.steps);
TimingFunction.instances = {};
TimingFunction.for = function (name) {
	if (TimingFunction.instances[name]) return TimingFunction.instances[name];
	if (TimingFunction.functions[name]) return TimingFunction.instances[name] = new TimingFunction.functions[name]();
	if (name.indexOf('(') == -1) return TimingFunction.for('step-start');
	var x = name.substring(0, name.indexOf('('));
	if (TimingFunction.functions[x]) {
		var argList = name.substring(name.indexOf('(') + 1, name.indexOf(')') + 1);
		argList = argList.split(',').map(function (v) {
			return v.replace(/^\s*/, '').replace(/\s*$/, '');
		}).map(function (v) {
			return isNaN(Number(v)) ? v : Number(v);
		});
	}
};

var AnimationHelper = function () {
	function AnimationHelper(duration, func, callback, finishCallback) {
		_classCallCheck(this, AnimationHelper);

		this.timingFunc = TimingFunction.for(func);
		this.duration = duration;
		this.callback = callback;
		this.finishCallback = finishCallback || function () {};
		this.ended = false;
	}

	_createClass(AnimationHelper, [{
		key: 'start',
		value: function start() {
			this.startTime = Date.now();
			this.run();
		}
	}, {
		key: 'stop',
		value: function stop() {
			if (!this.ended) {
				this.ended = true;
				this.finishCallback(false);
			}
		}
	}, {
		key: 'run',
		value: function run() {
			var _this9 = this;

			if (this.ended) return;

			var T = Date.now() - this.startTime;
			var P = T / this.duration;
			P = Math.min(1, P);
			P = Math.max(0, P);

			this.callback(this.timingFunc.value(P));
			if (P < 1) {
				requestAnimationFrame(function () {
					return _this9.run();
				});
			} else {
				this.ended = true;
				this.finishCallback(true);
			}
		}
	}]);

	return AnimationHelper;
}();

exports.default = AnimationHelper;